var ja = {};
module['exports'] = ja;
ja.title = "Japanese";
ja.address = require("./address");
ja.phone_number = require("./phone_number");
ja.cell_phone = require("./cell_phone");
ja.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/index.js
// module id = 960
// module chunks = 0